import FileSearchOutlined from '@ant-design/icons/FileSearchOutlined';
import TableOutlined from '@ant-design/icons/TableOutlined';

const icons = {
  FileSearchOutlined,
  TableOutlined
};

const appraisals = {
  id: 'group-appraisals',
  title: '감정 관리',
  type: 'group',
  children: [
    {
      id: 'expected-fees',
      title: '예상 감정료 목록',
      type: 'item',
      url: '/expected-fees',
      icon: icons.FileSearchOutlined,
      breadcrumbs: false
    },
    {
      id: 'contents',
      title: '감정 목록',
      type: 'item',
      url: '/contents',
      icon: icons.TableOutlined,
      breadcrumbs: false
    }
  ]
};

export default appraisals;
